import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from "@cinch-labs/design-system";
import styles from "./header.module.css";
export const ReviewsPageHeader = ({ title , subtitle  })=>/*#__PURE__*/ _jsxs("section", {
        className: styles.reviewsHeader,
        "data-testid": "reviews-hub-title",
        children: [
            /*#__PURE__*/ _jsx(Text, {
                fontWeight: "bold",
                fontSize: "4xl",
                element: "h1",
                children: title
            }),
            /*#__PURE__*/ _jsx(Text, {
                className: styles.subtitle,
                fontWeight: "light",
                fontSize: "xxl",
                children: subtitle
            })
        ]
    });
